/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface TaskLiteDTO { 
    dateCreation?: Date;
    dateExec?: Date;
    dateFin?: Date;
    etlId?: string;
    failures?: number;
    id?: string;
    /** Fin de la dernière exécution réelle (import), même si la tâche reste ouverte (erreurs à corriger, `dateFin` alors absent). Absent si aucun import n'a encore eu lieu. */
    lastExecutionEnd?: Date;
    nbTotalLines?: number;
    owner: string;
    param?: string;
    status: string;
    successes?: number;
    tenant?: string;
    type: string;
}
